import React, {useState} from 'react';
import {makeStyles} from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import {PtrnAlineacion, PtrnCampoDistribucionGrid, PtrnCampoEditableTab} from '../../patronTypes';
import PtrnTabs from '../CampoEditable/PtrnTabs';

interface TabPanelProps {
   children?: React.ReactNode;
   index: number;
   value: number;
}

function PtrnTabsPanel(props: TabPanelProps) {
   const {children, value, index, ...other} = props;

   return (
      <div
         style={{width: '100%'}}
         role="tabpanel"
         hidden={value !== index}
         id={`ptrn-tabs-grid-body-panel-${index}`}
         {...other}
      >
         {value === index && <Box sx={{p: 1}}>{children}</Box>}
      </div>
   );
}

const useStyles = makeStyles()((theme) => ({
   tabPanelGridContainer: {
      border: 'solid 1px',
      borderColor: theme.palette.divider,
      borderRadius: 5
   }
}));

//#region PtrnTabs
export function PtrnTabsGroup<T>({
   tabList,
   label,
   alineacionTabs,
   TabContentComponent,
   distribucionContainer,
   ruta,
   ...other
}: {
   tabList: PtrnCampoEditableTab[];
   label?: string;
   TabContentComponent: React.ElementType;
   distribucionContainer: PtrnCampoDistribucionGrid;
   alineacionTabs: PtrnAlineacion;
   ruta?: string[];
} & T) {
   const {classes} = useStyles();
   const [selectedTab, setselectedTab] = useState(0);
   const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setselectedTab(newValue);
   };
   const idCompPrefix = 'ptrn-tabs-group';
   //#region >ret main
   return (
      <Grid id={`${idCompPrefix}-grid-root`} {...distribucionContainer} container item spacing={1}>
         <Grid id={`${idCompPrefix}-grid-header`} container item xs={12} alignItems="center">
            {label && (
               <Grid id={`${idCompPrefix}-grid-header-label`} item xs={4}>
                  <Typography title={label} variant="h6" textOverflow="ellipsis" noWrap>
                     {label}
                  </Typography>
               </Grid>
            )}
            <Grid
               id={`${idCompPrefix}-grid-header-grid`}
               container
               item
               xs={label ? 8 : 12}
               justifyContent={alineacionTabs === PtrnAlineacion.right ? 'flex-end' : 'flex-start'}
            >
               <PtrnTabs
                  selectedTab={selectedTab}
                  onSelectedTabChange={handleChange}
                  tabList={tabList}
                  genTabProps={(currConf) => {
                     return {label: currConf.label};
                  }}
                  mostrarCerrar={false}
               />
            </Grid>
         </Grid>
         <Grid
            id={`${idCompPrefix}-grid-body`}
            container
            item
            xs={12}
            className={classes.tabPanelGridContainer}
         >
            {tabList.map((currConf, inx) => (
               <PtrnTabsPanel key={currConf.name} value={selectedTab} index={inx}>
                  <TabContentComponent {...other} campos={currConf.campos} ruta={ruta} />
               </PtrnTabsPanel>
            ))}
         </Grid>
      </Grid>
   );
   //#endregion
}
//#endregion

export default PtrnTabsGroup;
